import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { ModuleFE_Expression } from '@app/hcs-frontend';
/**
 * Resolve all variables from the resolution functions
 * @param resolutionFunctions All resolution functions defined in the editor
 * @private
 */
export const resolveResolutionFunctionVariables = (resolutionFunctions) => {
    return resolutionFunctions.reduce((variableIds, currentResolutionFunction) => {
        let collectedVariables = [];
        if (currentResolutionFunction._refs) {
            collectedVariables = collectedVariables.concat(resolveExpressionVariables(currentResolutionFunction));
        }
        return [...variableIds, ...collectedVariables];
    }, []);
};
const resolveExpressionVariables = (expression, visited = new Set()) => {
    const variableIds = [];
    // Check if the expression has already been visited
    if (visited.has(expression._id)) {
        throw new MUSTNeverHappenException(`Cyclic reference detected in expression with _id ${expression._id}`);
    }
    // Mark this expression as visited
    visited.add(expression._id);
    // First collect the resolution function itself variable ids from refs
    if (expression._refs?._variableIds) {
        variableIds.push(...expression._refs._variableIds);
    }
    // Then check if the expression references other expressions
    if (expression._refs?._exprIds.length) {
        // Run over all the expression ids and recursively collect all ids from the sub expressions
        for (const exprId of expression._refs._exprIds) {
            const subExpression = ModuleFE_Expression.cache.unique(exprId);
            if (!subExpression) {
                throw new MUSTNeverHappenException(`Expression with id ${exprId} not found`);
            }
            variableIds.push(...resolveExpressionVariables(subExpression, visited));
        }
    }
    // Remove this expression from the visited set before returning
    visited.delete(expression._id);
    return variableIds;
};
//# sourceMappingURL=utils.js.map